<template>
  <div class="admin-banners-wrap">
    <div class="mb-7 mt-5 d-flex flex-wrap">
      <h2 class="headline">Web Ads</h2>
      <v-spacer></v-spacer>
      <v-btn
        @click="$root.$emit('CreateBanner', topics)"
        color="success"
      >
        <v-icon left>mdi-card-plus</v-icon>
        Create Web Ad
      </v-btn>
    </div>
    <div class="mb-3">
      <div class="body-2">Advertiser Topics:</div>
      <template v-if="!no_data.includes(topics) && topics.length > 0">
        <v-chip
          v-for="item in topics"
          :key="item.id"
          small
          class="my-1 mr-2"
          color="primary"
        >
          {{ decodeHTMLEntities(item.name) }}
        </v-chip>
      </template>
      <div v-else class="body-2 mb-3 grey--text">
        There are no selected topics for this advertiser.
      </div>
    </div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{'items-per-page-options': [10, 20]}"
        mobile-breakpoint="100"
        class="table-org my-sticky-last-column-table"
      >
        <template v-slot:item="{item}">
          <tr class="items-body-row">
            <td>
              <span v-if="!no_data.includes(item.id)">{{ item.id }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.status)">{{ item.status }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.url)">{{ item.url }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.banner_type)">{{ item.banner_type }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.photo)" @click="$root.$emit('openImage', item.image)" class="pointer action-link">{{ item.photo }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.topics)">{{ formatTopics(item.topics) }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.alt_text)">{{ item.alt_text }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.global)">{{ `${Boolean(item.global) ? 'Yes' : 'No'}` }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <v-flex style="min-width: 125px;">
                <v-tooltip top class="mb-2" v-if="item.status == 'pending'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                            v-on="on"
                            @click="$root.$emit('ApproveBanner', item)"
                            icon
                            class="mx-0"
                            color="primary"
                    >
                      <v-icon>mdi-briefcase-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Approve</span>
                </v-tooltip>
                <v-tooltip 
                  top
                  class="mb-2"
                  v-if="!no_data.includes(organization.global) &&
                  Boolean(organization.global) &&
                  !no_data.includes(item.global) &&
                  !Boolean(item.global)"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                            v-on="on"
                            @click="$root.$emit('MakeBannerGlobal', item)"
                            icon
                            class="mx-0"
                            color="primary"
                    >
                      <v-icon>mdi-earth</v-icon>
                    </v-btn>
                  </template>
                  <span>Make Global</span>
                </v-tooltip>
                <v-tooltip
                  top
                  class="mb-2">
                  <template v-slot:activator="{ on }">
                    <v-btn
                            v-on="on"
                            @click="$root.$emit('RenameBannerName', item)"
                            icon
                            class="mx-0"
                            color="primary"
                    >
                      <v-icon>mdi-rename-box</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Image Name</span>
                </v-tooltip>
                <v-tooltip
                  top
                  class="mb-2">
                  <template v-slot:activator="{ on }">
                    <v-btn
                            v-on="on"
                            @click="$root.$emit('EditAltText', item)"
                            icon
                            class="mx-0"
                            color="primary"
                    >
                      <v-icon>mdi-tag</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Alt Text</span>
                </v-tooltip>
                <v-tooltip top class="mb-2">
                  <template v-slot:activator="{ on }">
                    <v-btn
                            v-on="on"
                            @click="$root.$emit('DisableBanner', item)"
                            icon
                            class="mx-0"
                            color="error"
                    >
                      <v-icon>mdi-close-box</v-icon>
                    </v-btn>
                  </template>
                  <span>Disable</span>
                </v-tooltip>
              </v-flex>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <create-banner @done="getWebAds"></create-banner>
    <approve-banner @done="getWebAds"></approve-banner>
    <disable-banner @done="getWebAds"></disable-banner>
    <make-banner-global @done="getWebAds"></make-banner-global>
    <rename-banner-name @done="getWebAds"></rename-banner-name>
    <edit-alt-text @done="getWebAds"></edit-alt-text>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import CreateBanner from "./CreateBanner"
import ApproveBanner from "./../ApproveBanner"
import DisableBanner from "./../DisableBanner"
import MakeBannerGlobal from "./MakeBannerGlobal"
import RenameBannerName from "./RenameBannerName"
import EditAltText from "./EditAltText"

export default {
  name: 'WebAd',
  components: {
    CreateBanner,
    ApproveBanner,
    MakeBannerGlobal,
    RenameBannerName,
    EditAltText,
    DisableBanner
  },
  data: () => ({
    no_data: [null, "", undefined, "null"],
    headers: [
      { text: "ID", value: "id", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "URL", value: "url", sort_column: 1 },
      { text: "Banner Type", value: "banner_type", sort_column: 3 },
      { text: "Ad Image", value: "photo", sort_column: 2 },
      { text: "Topics", value: "topics", sortable: false },
      { text: "Alt Text", value: "alt_text", sortable: false },
      { text: "Global", value: "global", sortable: false },
      { text: "Actions", value: "details", sortable: false, align: "left" }
    ],
    items: [],
    totalItems: 0,
    search: "",
    options: {},
    loading: false,
    loadingAds: false,
    loadingAdvertiser: false,
    organization: {},
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "asc"
    },
    topics: [],
    loadingAdvertiserTopics: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),
  watch: {
    pagination: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.getWebAds();
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        this.pagination.page = 1;
        this.getWebAds();
      }
    }, 1000)
  },
  mounted() {
    this.initialize()
    this.getAdvertiserTopics()
  },
  methods: {
    initialize() {
      this.loading = true
      Promise.all([this.getWebAds(), this.getAdvertiserDetails()])
        .then(values => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        });
    },
    getWebAds() {
      this.loadingAds = true;
      const { sortBy, descending, page, rowsPerPage } = this.options;
      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        this.headers.some(i => i.value === sortBy && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy
        ).sort_column;
      }
      this.tableData.dir = descending === true ? "asc" : "desc";

      this.tableData.page = page;
      this.tableData.search = this.search;
      this.tableData.draw++;
      this.draw = this.tableData.draw;

      this.tableData.type = 'web'
      this.tableData.organization_id = this.$route.params.organization_id

      return new Promise((resolve, reject) => {
        ApiService.get("/admin/banners", this.tableData)
          .then(response => {
            this.items = response.data.banners.data
            this.totalItems = response.data.banners.total
            this.loadingAds = false
            resolve();
          })
          .catch(error => {
            this.loadingAds = false
            console.log(error.message);
            reject();
          });
      });
    },
    getAdvertiserTopics (organization_id = this.$route.params.organization_id) {
      this.loadingAdvertiserTopics = true;
      return new Promise((resolve, reject) => {
        ApiService.get(`/admin/organization/${organization_id}/topics`)
          .then(response => {
            let data = response.data;
            this.topics = data.organization_topics
            this.loadingAdvertiserTopics = false
            resolve(data);
          })
          .catch(({ response }) => {
            this.loadingAdvertiserTopics = false
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(
                response.data.error
              );
            }
            reject();
          });
      });
    },
    getAdvertiserDetails () {
      this.loadingAdvertiser = true;
      return new Promise((resolve, reject) => {
        ApiService.get(`/admin/organization/${this.$route.params.organization_id}/show`)
          .then(response => {
            this.organization = response.data.organization
            this.loadingAdvertiser = false
            resolve();
          })
          .catch(({ response }) => {
            this.loadingAdvertiser = false
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(
                response.data.error
              );
            }
            reject();
          });
      });
    },
    decodeHTMLEntities(i) {
      return _.unescape(i)
    },
    formatTopics(topics) {
      return String(topics).split(',').map(i => this.decodeHTMLEntities(i)).join(', ')
    }
  }
}
</script>
